import { render, staticRenderFns } from "./ContinueDialog.vue?vue&type=template&id=35075d2d&"
import script from "./ContinueDialog.vue?vue&type=script&lang=js&"
export * from "./ContinueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports